import { render, staticRenderFns } from "./draft.vue?vue&type=template&id=4d50457c&scoped=true"
import script from "./draft.vue?vue&type=script&lang=js"
export * from "./draft.vue?vue&type=script&lang=js"
import style0 from "./draft.vue?vue&type=style&index=0&id=4d50457c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d50457c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d50457c')) {
      api.createRecord('4d50457c', component.options)
    } else {
      api.reload('4d50457c', component.options)
    }
    module.hot.accept("./draft.vue?vue&type=template&id=4d50457c&scoped=true", function () {
      api.rerender('4d50457c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hr/recruiter/draft.vue"
export default component.exports